// sessionStorage key used to carry the intended destination (e.g. a deep
// link from an email) across the full-page MSAL redirect to Microsoft and back.
export const POST_LOGIN_REDIRECT_KEY = 'aays_post_login_redirect';
